import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Contact from "./Contact";
import BigBreadcrumb from "./BigBreadCrumb";
import "../../assets/styles/layout.css";
import {useRecoilState} from "recoil";
import { companyState } from "../states";

export default function Layout({ children, stack }) {
  
  const [website] = useRecoilState(companyState);
  
  return (
    <div className="flex-auto overflow-auto">
      <Header />
      {stack && <BigBreadcrumb stack={stack} />}
      {children}
      <Contact website={website} />
      <Footer />
    </div>
  );
}
